module.exports = __webpack_public_path__ + "img/horizontal_4_2_8004.4e940585.png";